import { useEffect as e, useRef as t, useState as n } from "react";
//#region src/components/Header/base/useHeaderScroll.ts
var r = () => {
	let [r, i] = n(!0), a = t(0), o = t(null), s = t(!1), c = t(null), l = t(!1), u = t(null);
	return e(() => {
		let e = () => {
			s.current || (o.current = requestAnimationFrame(() => {
				let e = window.scrollY, t = e - a.current, n = c.current?.offsetHeight || 0, r = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
				if (e < 0 || e > r) {
					l.current = !0, a.current = e, s.current = !1;
					return;
				}
				if (l.current) {
					u.current = setTimeout(() => {
						l.current = !1;
					}, 150), a.current = e, s.current = !1;
					return;
				}
				i(t < 0 || e < n), a.current = e, s.current = !1;
			})), s.current = !0;
		};
		return window.addEventListener("scroll", e, { passive: !0 }), () => {
			window.removeEventListener("scroll", e), o.current && cancelAnimationFrame(o.current);
		};
	}, []), {
		isVisible: r,
		headerRef: c
	};
};
//#endregion
export { r as useHeaderScroll };
